<div class="p-3 pt-2 rounded-4">
    <div>
        <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0">
            <div class="p-3">Disputes</div>
        </div>
    </div>
    <div class="container-fluid">
        <div class="row bg-white p-2 pt-0">
            <div class="col-md-12 mt-4 mb-5">
                <div class="table-responsive">
<ag-grid-angular style="width: 100%; height: 600px" class="ag-theme-alpine"
    [columnDefs]="columnDefs" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
</ag-grid-angular>
@if (gridApi && !gridApi?.getRenderedNodes()?.length && gridApi?.getModel()?.getRowCount() === 0) {
<div class="text-center py-5">
    <i class="bi bi-inbox fs-1 text-muted"></i>
    <p class="text-muted mt-2">No dispute records found</p>
</div>
}
                </div>
            </div>
        </div>
    </div>
</div>